import { http } from '@/services/api/client';
import type { UploadedReportImage } from '@/types/report';

export async function uploadReportImage(file: File): Promise<UploadedReportImage> {
  const formData = new FormData();
  formData.append('file', file);
  const result = (await http.post('/uploads/report-images', formData)) as UploadedReportImage;
  return {
    ...result,
    id: String(result.id),
    previewUrl: URL.createObjectURL(file),
  };
}

export async function fetchReportImageAccessUrl(
  id: string,
): Promise<{ url: string; expiresIn: number }> {
  return http.get(`/uploads/report-images/${id}/access-url`) as Promise<{
    url: string;
    expiresIn: number;
  }>;
}
